<template>
    <main-content v-if="$can('manage-collective-gateways', 'ipg-gateway')" with_go_back_bar>
        <add-category-dedicated :action="addCategory"></add-category-dedicated>
        <filter-categories-dedicated :action="filterAction"></filter-categories-dedicated>
        <kt-datatable id="dCategory" ref="datatable_dedicated" v-bind="datatablePropsDedicated"></kt-datatable>
<!--        <kt-datatable></kt-datatable>-->

    </main-content>

</template>

<script>

import {dedicatedService, StarShopApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "./datatable/categories-columns-dedicated";
import actionsColumn  from "./components/categories-actions-column-dedicated.vue";
import toastr from "toastr";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {i18n} from "@/plugins/i18n";
import AddCategoryDedicated from "@/views/collective/add-category-dedicated.vue";
import FilterCategoriesDedicated from "@/views/collective/filter-categories-dedicated.vue";
import MainContent from "@/components/main-content.vue";

export default {
    components: {
        MainContent,
        FilterCategoriesDedicated, AddCategoryDedicated,
    },
    data() {
        return {
            query: {
                show_all_categories: 0
            }
        }
    },
    computed: {
        datatablePropsDedicated() {
            return {
                id: "dedicated_categories_datatable",
                data: {
                    type: "remote",
                    source: {
                        read: {
                            url: StarShopApiUrl.path("dedicated/admin/categories"),
                            method: "GET",
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data.data;
                            },
                            params: {
                                query: this.query,
                            },
                        },
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: columns,
                actions: actionsColumn,
            };
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: true,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        addCategory(e, data) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    title : {
                        required: true,
                    }
                },
            });

            if(!form.valid()) {
                return
            }
            const priorities = data.dedicated_ids;

            let highestFilledPriority = -1;

            for (let i = priorities.length - 1; i >= 0; i--) {
                if (priorities[i] && priorities[i] !== '') {
                    highestFilledPriority = i;
                    break;
                }
            }

            if (highestFilledPriority !== -1) {
                for (let i = 0; i < highestFilledPriority; i++) {
                    if (!priorities[i] || priorities[i] === '') {
                        return this.showMsg(form, 'danger', i18n.t('transaction_routing.cat_dedicated_shop_id_by_priority_alert'));
                    }
                }
            }
            let cleaned_dedicated_ids = data.dedicated_ids.filter(value => value !== null && value !== '');
            let unique_dedicated_ids = cleaned_dedicated_ids.filter((e, i, self) => i === self.indexOf(e));
            if (cleaned_dedicated_ids.length !== unique_dedicated_ids.length) {
                return this.showMsg(form, 'danger', i18n.t('transaction_routing.cat_dedicated_shop_id_repeated_alert'));
            }
            let params = {
                title: data.title,
                dedicated_ids: cleaned_dedicated_ids,
            }

            KTApp.progress(btn)
            dedicatedService.addCategory(params)
                .then(response => {
                    this.toastr.success(response.data.message)
                })
                .catch(({response}) => {
                    this.toastr.error(i18n.t('message.an_error_accord'))
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                    if (this.$refs.datatable_dedicated.KTDatatable) {
                        this.$refs.datatable_dedicated.reload();
                    }
                })
        },
        filterAction(e, query) {
            this.query = query;
            if (this.$refs.datatable_dedicated.KTDatatable) {
                this.$refs.datatable_dedicated.reload();
            }
        },
        checkbox_changed(e) {
            let checkbox = $('#category_checkbox')

            if (checkbox.is(":checked"))
                this.query.show_all_categories = 1
            else
                this.query.show_all_categories = 0

            if (this.$refs.datatable_dedicated.KTDatatable) {
                this.$refs.datatable_dedicated.reload()
            }
        }
    }
}
</script>

<style scoped>
.switch-div {
    width: fit-content;
    padding: 8px 27px;
    background: #fff;
    box-shadow: 0 0 7px 0 #9c9c9c5e;
}
.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #6aad27;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}
.slider.round {
    border-radius: 50px;
}

.slider.round:before {
    border-radius: 50px;
}

.info-icon {
    cursor: pointer;
    color: #0f9af0;
    display: inline-block;
}
</style>